<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrighta"><a id="page_iv">© 2008 by David Williams</a></p><a id="page_iv">
<p class="copyright">All rights reserved.</p>
<p class="copyright">No part of this book may be reproduced, in any form,</p>
<p class="copyright">without written permission from the publisher.</p>
<p class="copyright1">Requests for permission to reproduce selections from this book should be mailed to:</p>
<p class="copyright">Permissions Department, The New Press, 38 Greene Street, New York, NY 10013.</p>
<p class="copyright1">Published in the United States by The New Press, New York, 2008</p>
<p class="copyright">Distributed by W. W. Norton &amp; Company, Inc., New York</p>
<p class="copyright1"><span class="small">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="copyright2">Williams, David, 1959–</p>
<p class="copyrighti">Bitterly divided : the South’s inner Civil War / David Williams.</p>
<p class="copyrighti-ind">p. cm.</p>
<p class="copyrighti">Includes bibliographical references and index.</p>
<p class="copyrighti">ISBN 978-1-59558-108-2 (hc.)</p>
<p class="copyrighti-ind">1. Confederate States of America—Social conditions. 2. United States—History—Civil War, 1861–1865—Social aspects. 3. Social conflict—Southern States—History—19th century. 4. Social classes—Southern States—History—19th century. 5. Southern States—Race relations—History—19th century. I. Title.</p>
<p class="copyrightia">F214.W564 2008</p>
<p class="copyrighti">973.7'13—dc22</p>
<p class="copyright-right">2007045285</p>
<p class="copyright1">The New Press was established in 1990 as a not-for-profit alternative to the large, commercial publishing houses currently dominating the book publishing industry. The New Press operates in the public interest rather than for private gain, and is committed to publishing, in innovative ways, works of educational, cultural, and community value that are often deemed insufficiently profitable.</p>
</a><p class="copyright1"><a id="page_iv"></a><a href="http://www.thenewpress.com" target="_blank"><span class="underline">www.thenewpress.com</span></a></p>
<p class="copyright1"><em class="italic">Composition by Westchester Book Composition</em></p>
<p class="copyright"><em class="italic">This book was set in Janson</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6d2edf8f